module.exports = __webpack_public_path__ + "img/duanxin.1b1e986e.svg";